import React from 'react';

import type { NovesHistoryFilterValue } from 'types/api/noves';

import useIsInitialLoading from 'lib/hooks/useIsInitialLoading';
import { useI18n } from 'lib/i18n/context';
import PopoverFilterRadio from 'ui/shared/filters/PopoverFilterRadio';

import { ADDRESS_ACCOUNT_HISTORY_FILTER_OPTION_KEYS } from './i18n';

interface Props {
  hasActiveFilter: boolean;
  defaultFilter: NovesHistoryFilterValue;
  onFilterChange: (nextValue: string | Array<string>) => void;
  isLoading?: boolean;
}

const AccountHistoryFilter = ({ onFilterChange, defaultFilter, hasActiveFilter, isLoading }: Props) => {
  const { t } = useI18n();
  const isInitialLoading = useIsInitialLoading(isLoading);
  const options = ADDRESS_ACCOUNT_HISTORY_FILTER_OPTION_KEYS.map(({ labelKey, ...option }) => ({
    ...option,
    label: t(labelKey),
  }));

  return (
    <PopoverFilterRadio
      name="account_history_filter"
      options={ options }
      onChange={ onFilterChange }
      hasActiveFilter={ hasActiveFilter }
      isLoading={ isInitialLoading }
      defaultValue={ defaultFilter || options[0].value }
    />
  );
};

export default React.memo(AccountHistoryFilter);
